<template>
<div>
  <v-select box v-model="selectedRegion" :items="regions" :label="$t('schedule.region')" :rules="rules"></v-select>
  <v-select box v-model="selectedTimezone" :items="timezones" :label="$t('schedule.timezone')" :rules="rules"></v-select>
</div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'TimezoneSelector',
  props: {
    value: {
      type: String,
    }
  },
  data() {
    return {
      allTimezones: moment.tz.names(),
      selectedRegion: null,
      rules: [
        v => !!v || this.$t('schedule.timezone_required')
      ]
    }
  },
  computed: {
    selectedTimezone: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    regions() {
      let data = this.allTimezones
        .filter(t => t.indexOf('/') > -1)
        .map(t => t.split('/')[0])
        .reduce((acc, cur) => {
          acc[cur] = true;
          return acc;
        }, {});
      return Object.keys(data).map(k => ({
        value: k,
        text: k
      }));
    },
    timezones() {
      return this.allTimezones
        .filter(t => t.startsWith(this.selectedRegion))
        .map(k => ({
          value: k,
          text: k
        }));
    }
  },
  watch: {
    selectedTimezone(val) {
      this.selectedRegion = (val || '').split('/')[0];
    }
  },
  mounted() {
    let guess = moment.tz.guess();
    this.selectedTimezone = this.selectedTimezone || guess;
    this.selectedRegion = (this.selectedTimezone || guess).split('/')[0];
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schedule/TimezoneSelector.vue